module.exports = __webpack_public_path__ + "img/15.518792d2.jpg";